import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/regenerator";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ArgumentNullError, ConnectionState, createNoDashGuid, EventSource, MessageType, ServiceEvent } from "../common/Exports";
import { CancellationErrorCode, CancellationReason, PropertyCollection, PropertyId, ResultReason, SpeechSynthesisBookmarkEventArgs, SpeechSynthesisEventArgs, SpeechSynthesisResult, SpeechSynthesisVisemeEventArgs, SpeechSynthesisWordBoundaryEventArgs } from "../sdk/Exports";
import { AgentConfig, CancellationErrorCodePropertyName, MetadataType, SynthesisAudioMetadata, SynthesisContext, SynthesisTurn } from "./Exports";
import { SpeechConnectionMessage } from "./SpeechConnectionMessage.Internal";
export var SynthesisAdapterBase = /*#__PURE__*/function () {
  function SynthesisAdapterBase(authentication, connectionFactory, synthesizerConfig, speechSynthesizer, audioDestination) {
    var _this = this;

    _classCallCheck(this, SynthesisAdapterBase);

    this.speakOverride = undefined;
    this.receiveMessageOverride = undefined;
    this.connectImplOverride = undefined;
    this.configConnectionOverride = undefined;

    this.sendSynthesisContext = function (connection) {
      var synthesisContextJson = _this.synthesisContext.toJSON();

      if (synthesisContextJson) {
        return connection.send(new SpeechConnectionMessage(MessageType.Text, "synthesis.context", _this.privSynthesisTurn.requestId, "application/json", synthesisContextJson));
      }

      return;
    };

    this.sendSpeechServiceConfig = function (connection, SpeechServiceConfigJson) {
      if (SpeechServiceConfigJson) {
        return connection.send(new SpeechConnectionMessage(MessageType.Text, "speech.config", _this.privSynthesisTurn.requestId, "application/json", SpeechServiceConfigJson));
      }
    };

    this.sendSsmlMessage = function (connection, ssml, requestId) {
      return connection.send(new SpeechConnectionMessage(MessageType.Text, "ssml", requestId, "application/ssml+xml", ssml));
    };

    if (!authentication) {
      throw new ArgumentNullError("authentication");
    }

    if (!connectionFactory) {
      throw new ArgumentNullError("connectionFactory");
    }

    if (!synthesizerConfig) {
      throw new ArgumentNullError("synthesizerConfig");
    }

    this.privAuthentication = authentication;
    this.privConnectionFactory = connectionFactory;
    this.privSynthesizerConfig = synthesizerConfig;
    this.privIsDisposed = false;
    this.privSpeechSynthesizer = speechSynthesizer;
    this.privSessionAudioDestination = audioDestination;
    this.privSynthesisTurn = new SynthesisTurn();
    this.privConnectionEvents = new EventSource();
    this.privServiceEvents = new EventSource();
    this.privSynthesisContext = new SynthesisContext(this.privSpeechSynthesizer);
    this.privAgentConfig = new AgentConfig();
    this.connectionEvents.attach(function (connectionEvent) {
      if (connectionEvent.name === "ConnectionClosedEvent") {
        var connectionClosedEvent = connectionEvent;

        if (connectionClosedEvent.statusCode !== 1000) {
          _this.cancelSynthesisLocal(CancellationReason.Error, connectionClosedEvent.statusCode === 1007 ? CancellationErrorCode.BadRequestParameters : CancellationErrorCode.ConnectionFailure, connectionClosedEvent.reason + " websocket error code: " + connectionClosedEvent.statusCode);
        }
      }
    });
  }

  _createClass(SynthesisAdapterBase, [{
    key: "synthesisContext",
    get: function get() {
      return this.privSynthesisContext;
    }
  }, {
    key: "agentConfig",
    get: function get() {
      return this.privAgentConfig;
    }
  }, {
    key: "connectionEvents",
    get: function get() {
      return this.privConnectionEvents;
    }
  }, {
    key: "serviceEvents",
    get: function get() {
      return this.privServiceEvents;
    }
  }, {
    key: "activityTemplate",
    get: function get() {
      return this.privActivityTemplate;
    },
    set: function set(messagePayload) {
      this.privActivityTemplate = messagePayload;
    }
  }, {
    key: "audioOutputFormat",
    set: function set(format) {
      this.privAudioOutputFormat = format;
      this.privSynthesisTurn.audioOutputFormat = format;

      if (this.privSessionAudioDestination !== undefined) {
        this.privSessionAudioDestination.format = format;
      }

      if (this.synthesisContext !== undefined) {
        this.synthesisContext.audioOutputFormat = format;
      }
    }
  }, {
    key: "isDisposed",
    value: function isDisposed() {
      return this.privIsDisposed;
    }
  }, {
    key: "dispose",
    value: function dispose(reason) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var connection;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.privIsDisposed = true;

                if (this.privSessionAudioDestination !== undefined) {
                  this.privSessionAudioDestination.close();
                }

                if (!this.privConnectionConfigurationPromise) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return this.privConnectionConfigurationPromise;

              case 5:
                connection = _context.sent;
                _context.next = 8;
                return connection.dispose(reason);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.connectImpl();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "sendNetworkMessage",
    value: function sendNetworkMessage(path, payload) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var type, contentType, connection;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = typeof payload === "string" ? MessageType.Text : MessageType.Binary;
                contentType = typeof payload === "string" ? "application/json" : "";
                _context3.next = 4;
                return this.fetchConnection();

              case 4:
                connection = _context3.sent;
                return _context3.abrupt("return", connection.send(new SpeechConnectionMessage(type, path, this.privSynthesisTurn.requestId, contentType, payload)));

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "Speak",
    value: function Speak(text, isSSML, requestId, successCallback, errorCallBack, audioDestination) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var ssml, connection, synthesisStartEventArgs, messageRetrievalPromise;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (isSSML) {
                  ssml = text;
                } else {
                  ssml = this.privSpeechSynthesizer.buildSsml(text);
                }

                if (!(this.speakOverride !== undefined)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return", this.speakOverride(ssml, requestId, successCallback, errorCallBack));

              case 3:
                this.privSuccessCallback = successCallback;
                this.privErrorCallback = errorCallBack;
                this.privSynthesisTurn.startNewSynthesis(requestId, text, isSSML, audioDestination);
                _context4.prev = 6;
                _context4.next = 9;
                return this.connectImpl();

              case 9:
                _context4.next = 11;
                return this.fetchConnection();

              case 11:
                connection = _context4.sent;
                _context4.next = 14;
                return this.sendSynthesisContext(connection);

              case 14:
                _context4.next = 16;
                return this.sendSsmlMessage(connection, ssml, requestId);

              case 16:
                synthesisStartEventArgs = new SpeechSynthesisEventArgs(new SpeechSynthesisResult(requestId, ResultReason.SynthesizingAudioStarted));

                if (!!this.privSpeechSynthesizer.synthesisStarted) {
                  this.privSpeechSynthesizer.synthesisStarted(this.privSpeechSynthesizer, synthesisStartEventArgs);
                }

                messageRetrievalPromise = this.receiveMessage();
                _context4.next = 25;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](6);
                this.cancelSynthesisLocal(CancellationReason.Error, CancellationErrorCode.ConnectionFailure, _context4.t0);
                return _context4.abrupt("return", Promise.reject(_context4.t0));

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 21]]);
      }));
    } // Cancels synthesis.

  }, {
    key: "cancelSynthesis",
    value: function cancelSynthesis(requestId, cancellationReason, errorCode, error) {
      var properties = new PropertyCollection();
      properties.setProperty(CancellationErrorCodePropertyName, CancellationErrorCode[errorCode]);
      var result = new SpeechSynthesisResult(requestId, ResultReason.Canceled, undefined, error, properties);

      if (!!this.privSpeechSynthesizer.SynthesisCanceled) {
        var cancelEvent = new SpeechSynthesisEventArgs(result);

        try {
          this.privSpeechSynthesizer.SynthesisCanceled(this.privSpeechSynthesizer, cancelEvent);
          /* tslint:disable:no-empty */
        } catch (_a) {}
      }

      if (!!this.privSuccessCallback) {
        try {
          this.privSuccessCallback(result);
          /* tslint:disable:no-empty */
        } catch (_b) {}
      }
    } // Cancels synthesis.

  }, {
    key: "cancelSynthesisLocal",
    value: function cancelSynthesisLocal(cancellationReason, errorCode, error) {
      if (!!this.privSynthesisTurn.isSynthesizing) {
        this.privSynthesisTurn.onStopSynthesizing();
        this.cancelSynthesis(this.privSynthesisTurn.requestId, cancellationReason, errorCode, error);
      }
    }
  }, {
    key: "processTypeSpecificMessages",
    value: function processTypeSpecificMessages(connectionMessage, successCallback, errorCallBack) {
      return true;
    }
  }, {
    key: "receiveMessage",
    value: function receiveMessage() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var connection, message, connectionMessage, audioWithHeader, ev, metadataList, _iterator, _step, metadata, wordBoundaryEventArgs, bookmarkEventArgs, visemeEventArgs, result, audioBuffer;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.fetchConnection();

              case 3:
                connection = _context5.sent;
                _context5.next = 6;
                return connection.read();

              case 6:
                message = _context5.sent;

                if (!(this.receiveMessageOverride !== undefined)) {
                  _context5.next = 9;
                  break;
                }

                return _context5.abrupt("return", this.receiveMessageOverride());

              case 9:
                if (!this.privIsDisposed) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return");

              case 11:
                if (message) {
                  _context5.next = 17;
                  break;
                }

                if (this.privSynthesisTurn.isSynthesizing) {
                  _context5.next = 16;
                  break;
                }

                return _context5.abrupt("return");

              case 16:
                return _context5.abrupt("return", this.receiveMessage());

              case 17:
                this.privServiceHasSentMessage = true;
                connectionMessage = SpeechConnectionMessage.fromConnectionMessage(message);

                if (!(connectionMessage.requestId.toLowerCase() === this.privSynthesisTurn.requestId.toLowerCase())) {
                  _context5.next = 74;
                  break;
                }

                _context5.t0 = connectionMessage.path.toLowerCase();
                _context5.next = _context5.t0 === "turn.start" ? 23 : _context5.t0 === "response" ? 25 : _context5.t0 === "audio" ? 27 : _context5.t0 === "audio.metadata" ? 29 : _context5.t0 === "turn.end" ? 59 : 73;
                break;

              case 23:
                this.privSynthesisTurn.onServiceTurnStartResponse();
                return _context5.abrupt("break", 74);

              case 25:
                this.privSynthesisTurn.onServiceResponseMessage(connectionMessage.textBody);
                return _context5.abrupt("break", 74);

              case 27:
                if (this.privSynthesisTurn.streamId.toLowerCase() === connectionMessage.streamId.toLowerCase() && !!connectionMessage.binaryBody) {
                  this.privSynthesisTurn.onAudioChunkReceived(connectionMessage.binaryBody);

                  if (!!this.privSpeechSynthesizer.synthesizing) {
                    try {
                      audioWithHeader = SynthesisAdapterBase.addHeader(connectionMessage.binaryBody, this.privSynthesisTurn.audioOutputFormat);
                      ev = new SpeechSynthesisEventArgs(new SpeechSynthesisResult(this.privSynthesisTurn.requestId, ResultReason.SynthesizingAudio, audioWithHeader));
                      this.privSpeechSynthesizer.synthesizing(this.privSpeechSynthesizer, ev);
                    } catch (error) {// Not going to let errors in the event handler
                      // trip things up.
                    }
                  }

                  if (this.privSessionAudioDestination !== undefined) {
                    this.privSessionAudioDestination.write(connectionMessage.binaryBody);
                  }
                }

                return _context5.abrupt("break", 74);

              case 29:
                metadataList = SynthesisAudioMetadata.fromJSON(connectionMessage.textBody).Metadata;
                _iterator = _createForOfIteratorHelper(metadataList);
                _context5.prev = 31;

                _iterator.s();

              case 33:
                if ((_step = _iterator.n()).done) {
                  _context5.next = 50;
                  break;
                }

                metadata = _step.value;
                _context5.t1 = metadata.Type;
                _context5.next = _context5.t1 === MetadataType.WordBoundary ? 38 : _context5.t1 === MetadataType.Bookmark ? 42 : _context5.t1 === MetadataType.Viseme ? 45 : 48;
                break;

              case 38:
                this.privSynthesisTurn.onWordBoundaryEvent(metadata.Data.text.Text);
                wordBoundaryEventArgs = new SpeechSynthesisWordBoundaryEventArgs(metadata.Data.Offset, metadata.Data.text.Text, metadata.Data.text.Length, this.privSynthesisTurn.currentTextOffset);

                if (!!this.privSpeechSynthesizer.wordBoundary) {
                  try {
                    this.privSpeechSynthesizer.wordBoundary(this.privSpeechSynthesizer, wordBoundaryEventArgs);
                  } catch (error) {// Not going to let errors in the event handler
                    // trip things up.
                  }
                }

                return _context5.abrupt("break", 48);

              case 42:
                bookmarkEventArgs = new SpeechSynthesisBookmarkEventArgs(metadata.Data.Offset, metadata.Data.Bookmark);

                if (!!this.privSpeechSynthesizer.bookmarkReached) {
                  try {
                    this.privSpeechSynthesizer.bookmarkReached(this.privSpeechSynthesizer, bookmarkEventArgs);
                  } catch (error) {// Not going to let errors in the event handler
                    // trip things up.
                  }
                }

                return _context5.abrupt("break", 48);

              case 45:
                this.privSynthesisTurn.onVisemeMetadataReceived(metadata);

                if (metadata.Data.IsLastAnimation) {
                  visemeEventArgs = new SpeechSynthesisVisemeEventArgs(metadata.Data.Offset, metadata.Data.VisemeId, this.privSynthesisTurn.getAndClearVisemeAnimation());

                  if (!!this.privSpeechSynthesizer.visemeReceived) {
                    try {
                      this.privSpeechSynthesizer.visemeReceived(this.privSpeechSynthesizer, visemeEventArgs);
                    } catch (error) {// Not going to let errors in the event handler
                      // trip things up.
                    }
                  }
                }

                return _context5.abrupt("break", 48);

              case 48:
                _context5.next = 33;
                break;

              case 50:
                _context5.next = 55;
                break;

              case 52:
                _context5.prev = 52;
                _context5.t2 = _context5["catch"](31);

                _iterator.e(_context5.t2);

              case 55:
                _context5.prev = 55;

                _iterator.f();

                return _context5.finish(55);

              case 58:
                return _context5.abrupt("break", 74);

              case 59:
                this.privSynthesisTurn.onServiceTurnEndResponse();
                _context5.prev = 60;
                _context5.next = 63;
                return this.privSynthesisTurn.getAllReceivedAudioWithHeader();

              case 63:
                audioBuffer = _context5.sent;
                result = new SpeechSynthesisResult(this.privSynthesisTurn.requestId, ResultReason.SynthesizingAudioCompleted, audioBuffer);

                if (!!this.privSuccessCallback) {
                  this.privSuccessCallback(result);
                }

                _context5.next = 71;
                break;

              case 68:
                _context5.prev = 68;
                _context5.t3 = _context5["catch"](60);

                if (!!this.privErrorCallback) {
                  this.privErrorCallback(_context5.t3);
                }

              case 71:
                if (this.privSpeechSynthesizer.synthesisCompleted) {
                  try {
                    this.privSpeechSynthesizer.synthesisCompleted(this.privSpeechSynthesizer, new SpeechSynthesisEventArgs(result));
                  } catch (e) {// Not going to let errors in the event handler
                    // trip things up.
                  }
                }

                return _context5.abrupt("break", 74);

              case 73:
                if (!this.processTypeSpecificMessages(connectionMessage)) {
                  // here are some messages that the derived class has not processed, dispatch them to connect class
                  if (!!this.privServiceEvents) {
                    this.serviceEvents.onEvent(new ServiceEvent(connectionMessage.path.toLowerCase(), connectionMessage.textBody));
                  }
                }

              case 74:
                return _context5.abrupt("return", this.receiveMessage());

              case 77:
                _context5.prev = 77;
                _context5.t4 = _context5["catch"](0);

              case 79:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 77], [31, 52, 55, 58], [60, 68]]);
      }));
    }
  }, {
    key: "connectImpl",
    value: function connectImpl() {
      var _this2 = this;

      var isUnAuthorized = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.privConnectionPromise) {
        return this.privConnectionPromise.then(function (connection) {
          if (connection.state() === ConnectionState.Disconnected) {
            _this2.privConnectionId = null;
            _this2.privConnectionPromise = null;
            _this2.privServiceHasSentMessage = false;
            return _this2.connectImpl();
          }

          return _this2.privConnectionPromise;
        }, function (error) {
          _this2.privConnectionId = null;
          _this2.privConnectionPromise = null;
          _this2.privServiceHasSentMessage = false;
          return _this2.connectImpl();
        });
      }

      this.privAuthFetchEventId = createNoDashGuid();
      this.privConnectionId = createNoDashGuid();
      this.privSynthesisTurn.onPreConnectionStart(this.privAuthFetchEventId, this.privConnectionId);
      var authPromise = isUnAuthorized ? this.privAuthentication.fetchOnExpiry(this.privAuthFetchEventId) : this.privAuthentication.fetch(this.privAuthFetchEventId);
      this.privConnectionPromise = authPromise.then(function (result) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
          var _this3 = this;

          var connection, response;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return this.privSynthesisTurn.onAuthCompleted(false);

                case 2:
                  connection = this.privConnectionFactory.create(this.privSynthesizerConfig, result, this.privConnectionId); // Attach to the underlying event. No need to hold onto the detach pointers as in the event the connection goes away,
                  // it'll stop sending events.

                  connection.events.attach(function (event) {
                    _this3.connectionEvents.onEvent(event);
                  });
                  _context6.next = 6;
                  return connection.open();

                case 6:
                  response = _context6.sent;

                  if (!(response.statusCode === 200)) {
                    _context6.next = 13;
                    break;
                  }

                  _context6.next = 10;
                  return this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode);

                case 10:
                  return _context6.abrupt("return", Promise.resolve(connection));

                case 13:
                  if (!(response.statusCode === 403 && !isUnAuthorized)) {
                    _context6.next = 17;
                    break;
                  }

                  return _context6.abrupt("return", this.connectImpl(true));

                case 17:
                  _context6.next = 19;
                  return this.privSynthesisTurn.onConnectionEstablishCompleted(response.statusCode, response.reason);

                case 19:
                  return _context6.abrupt("return", Promise.reject("Unable to contact server. StatusCode: ".concat(response.statusCode, ", ").concat(this.privSynthesizerConfig.parameters.getProperty(PropertyId.SpeechServiceConnection_Endpoint), " Reason: ").concat(response.reason)));

                case 20:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));
      }, function (error) {
        return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this.privSynthesisTurn.onAuthCompleted(true, error);

                case 2:
                  throw new Error(error);

                case 3:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));
      }); // Attach an empty handler to allow the promise to run in the background while
      // other startup events happen. It'll eventually be awaited on.

      this.privConnectionPromise.catch(function () {});
      return this.privConnectionPromise;
    }
  }, {
    key: "fetchConnection",
    value: function fetchConnection() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.privConnectionConfigurationPromise) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", this.privConnectionConfigurationPromise.then(function (connection) {
                  if (connection.state() === ConnectionState.Disconnected) {
                    _this4.privConnectionId = null;
                    _this4.privConnectionConfigurationPromise = null;
                    _this4.privServiceHasSentMessage = false;
                    return _this4.fetchConnection();
                  }

                  return _this4.privConnectionConfigurationPromise;
                }, function (error) {
                  _this4.privConnectionId = null;
                  _this4.privConnectionConfigurationPromise = null;
                  _this4.privServiceHasSentMessage = false;
                  return _this4.fetchConnection();
                }));

              case 2:
                this.privConnectionConfigurationPromise = this.configureConnection();
                _context8.next = 5;
                return this.privConnectionConfigurationPromise;

              case 5:
                return _context8.abrupt("return", _context8.sent);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    } // Takes an established websocket connection to the endpoint and sends speech configuration information.

  }, {
    key: "configureConnection",
    value: function configureConnection() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var connection;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.connectImpl();

              case 2:
                connection = _context9.sent;

                if (!(this.configConnectionOverride !== undefined)) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", this.configConnectionOverride(connection));

              case 5:
                _context9.next = 7;
                return this.sendSpeechServiceConfig(connection, this.privSynthesizerConfig.SpeechServiceConfig.serialize());

              case 7:
                return _context9.abrupt("return", connection);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }], [{
    key: "addHeader",
    value: function addHeader(audio, format) {
      if (!format.hasHeader) {
        return audio;
      }

      format.updateHeader(audio.byteLength);
      var tmp = new Uint8Array(audio.byteLength + format.header.byteLength);
      tmp.set(new Uint8Array(format.header), 0);
      tmp.set(new Uint8Array(audio), format.header.byteLength);
      return tmp.buffer;
    }
  }]);

  return SynthesisAdapterBase;
}();
SynthesisAdapterBase.telemetryDataEnabled = true;